export default function initIntroAnimation() {
    const intro = document.querySelector(".intro");

    if(intro) {
        intro.classList.add("reveal-active");
        setTimeout(() => {
            intro.classList.add("reveal-visible");
        }, 1);
    }
}